<script lang="ts">
  import {CatalystApp} from 'Catalyst/components/CatalystApp';
  import {Icon} from 'Catalyst/components/Icon';
  import {
    TierType,
    type IncentiveTier,
  } from 'Types/incentiveTier/incentiveTierTypes';
  import {
    shouldShowSubtitleList,
    tierSubtitleIcon,
    tierListIcon,
    getTierTitle,
    getTierSubtitle,
    getTierListMessage,
    formatDateTime,
  } from 'Utility/freeSharesCard/tierUtils';
  import {getIcon} from 'Catalyst/utility/getIcon';
  import IncentiveList from 'Components/IncentiveTiers/IncentiveList.svelte';
  import {whiteLabeling} from 'Store/WhiteLabelStore';
  import type {CssColor} from 'Catalyst/utility/theme';
  import TiersCountDown from 'Components/InvestorFlow/v2/Components/ProductPageDetails/TiersCountDown.svelte';

  export let incentiveTier: IncentiveTier;

  const tierType: TierType = incentiveTier.tierType;
  const title: string = incentiveTier.name;
  const mainTitle: string = getTierTitle(incentiveTier);
  const subtitleMessage: string = getTierSubtitle(incentiveTier);
  const subtitleIcon = getIcon(tierSubtitleIcon[tierType]);
  const listMessage = getTierListMessage(incentiveTier);
  const listIcon = getIcon(tierListIcon[tierType]);

  const shouldShowSubtitle = shouldShowSubtitleList.includes(tierType);
  const shouldShowCountdown =
    [TierType.TIME, TierType.TIME_VOLUME, TierType.TIME_LOYALTY].includes(
      tierType
    ) && incentiveTier.endAt;
  const formatEndAt: string = shouldShowCountdown
    ? new Date(incentiveTier.endAt).toISOString()
    : '';

  const brandColor = $whiteLabeling.primary_color as CssColor;
</script>

<CatalystApp
  brandColors={[
    {
      key: 'brand-color',
      value: brandColor,
    },
  ]}
>
  <div
    data-testid="product-page-incentive-tier-card"
    class="border-[0.063rem] border-[--palettes-brand-color-500] border-solid bg-[#ffffff] rounded-[1rem] flex flex-col pt-[1.25rem] px-[1.25rem] pb-[1.5rem] shadow-[0_4px_6px_-2px_rgba(16,24,40,0.08),0_12px_16px_-4px_rgba(16,24,40,0.14)]"
  >
    <div
      class="px-[1.25rem] pb-[0.75rem] flex row justify-between items-center"
    >
      <h2
        class="font-[Inter] text-sm font-medium leading-[1.25rem] text-left text-[--palettes-brand-color-500]"
      >
        {title}
      </h2>
      {#if shouldShowCountdown}
        <div class="flex justify-between">
          <div>
            <TiersCountDown EndAt={formatEndAt} />
          </div>
        </div>
      {/if}
    </div>
    {#if shouldShowSubtitle}
      <div
        class="flex p-3 rounded-md border border-[0.063rem] border-solid border-[#EAECF0] justify-between items-center bg-[#FCFCFD] mb-3"
      >
        <div>
          <span
            data-testid="tier-type"
            class="font-['Inter'] text-[1.125rem] font-medium leading-[1.75rem] text-left decoration-skip-ink-none text-[#344054]"
            >{mainTitle}</span
          >
          <span
            class="font-['Inter'] text-[18px] font-normal leading-[28px] text-left decoration-skip-ink-none text-[#667085]"
            >{subtitleMessage}</span
          >
        </div>
        <div
          class="tiers-card-icon-container bg-[#f1f1f1] rounded-full w-8 h-8 flex items-center justify-center"
        >
          <Icon
            class="text-[#777777]"
            name={subtitleIcon}
            size="24dp"
            density="compact"
          />
        </div>
      </div>
    {/if}
    <IncentiveList
      {listIcon}
      title={listMessage}
      fundedBy={formatDateTime(incentiveTier.fundedBy, 'd MMM yyyy, h:mma')}
      {incentiveTier}
    />
  </div>
</CatalystApp>
